import styled from 'styled-components';

const CategoryDescriptionSectionStyle = styled.section`
	--paddingSectionInner: var(--sp8x);
	--distanceGap: 72px;
	--translateImageTop: -72px;
	--paddingImage: 122%;
	--distanceGapTitleDescription: var(--sp6x);

	margin-bottom: var(--sectionDistance);
	padding: 0 calc(var(--contPaddingLR) - var(--paddingSectionInner));

	.catalog-wrapper {
		padding: 0 var(--paddingSectionInner);
		margin-top: var(--sectionDistance);
		background-color: rgba(176, 227, 217, 0.1);
	}

	.catalogWrapperDescription {
		display: grid;
		grid-template-columns: 3fr 2fr;

		.catalogDescription {
			display: flex;
			flex-direction: column;
			padding: var(--distanceGap) 0;
			padding-right: var(--distanceGap);
			gap: var(--distanceGapTitleDescription);
		}

		.catalog-image {
			height: fit-content;
			padding-top: var(--paddingImage);
			background-color: transparent;
			transform: translateY(calc(var(--distanceGap) * -1));
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--paddingSectionInner: var(--sp6x);
		--paddingImage: 110%;
		--distanceGap: var(--sp6x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--paddingSectionInner: var(--sp6x);
		--paddingImage: 125%;
		--distanceGap: var(--sp6x);
		--distanceGapTitleDescription: var(--sp4x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--paddingSectionInner: var(--sp4x);
		--paddingImage: 135%;
		--distanceGap: var(--sp4x);
		--distanceGapTitleDescription: var(--sp4x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--paddingSectionInner: var(--sp4x);
		--paddingImage: 122%;
		--distanceGap: var(--sp4x);
		--distanceGapTitleDescription: var(--sp5x);

		.catalogWrapperDescription {
			grid-template-columns: repeat(9, 1fr);
			grid-template-rows: 4fr auto;
		}

		.catalog-image {
			grid-area: 1/1/2/5;
		}

		.catalogDescription {
			padding-right: 0 !important;
			padding-top: 0 !important;
			grid-area: 2/1/3/10;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--paddingSectionInner: 0px;
		--paddingImage: 117%;
		--distanceGap: var(--sp4x);
		--distanceGapTitleDescription: var(--sp4x);

		padding: 0;

		.catalog-image {
			grid-area: 1/1/2/3;
		}

		.catalog-wrapper {
			padding: 0 calc(var(--contPaddingLR) - var(--paddingSectionInner));
		}

		.catalogDescription {
			grid-area: 2/1/3/3;
			padding: 0 !important;
			padding-bottom: var(--distanceGap) !important;
		}
	}
`;

export default CategoryDescriptionSectionStyle;
